export default __webpack_public_path__ + "static/media/empty-filtered-requests.40db5a39.svg";